import React, { useEffect, useState, useRef } from "react";
import SearchIcon from "./../../../../images/searchicon.png"
import {Link, useNavigate} from 'react-router-dom'
import N3rveLogo from './../../../../images/N3rveLogo.png'
import InstagramLogo from './../../../../images/instagramlogo.png'
import TwitterLogo from './../../../../images/twitterlogo.png'
import DiscordLogo from './../../../../images/discordlogo.png'
import DiscordIcon from './../../../../images/discordicon.png'
import purplebackicon from './../../../../images/purplebackicon.png'

function SupportList({infopageHeader,setInfoPageHeader}){
    const [search,setSearch] = useState();
    const navigate= useNavigate();

    const searchHelp = (value)=>{
        setSearch(value)
        searchQuery(value)
    }

    const [searchOptions,setSearchOptions] = useState([
        {
            "header":"How can I protect my account?",
            "desc":"Lorem ipsum dolor sit amet consectetur. Dui a habitasse aliquet et posuere pellentesque fames. "
        },
        {
            "header":"How can I protect my account?",
            "desc":"Lorem ipsum dolor sit amet consectetur. Dui a habitasse aliquet et posuere pellentesque fames. "
        },
        {
            "header":"How can I protect my account?",
            "desc":"Lorem ipsum dolor sit amet consectetur. Dui a habitasse aliquet et posuere pellentesque fames. "
        },
        {
            "header":"How can I protect my account?",
            "desc":"Lorem ipsum dolor sit amet consectetur. Dui a habitasse aliquet et posuere pellentesque fames. "
        }
    ])

    const [matchingsearch,setMatchingSearch] = useState([])

    const searchQuery = (value) =>{
        console.log(value)
        const match=[]
        searchOptions.map((searchmatch)=>{
            console.log(searchmatch)
            if(value.length!==0){
                if(searchmatch.header.toLowerCase().includes(value.toLowerCase())|| searchmatch.desc.toLowerCase().includes(value.toLowerCase())){
                    console.log("Match")
                    match.push(searchmatch)
                }
            }
            
        })
        setMatchingSearch(match)
        if(match.length===0 && value.length!==0){
            match.push({
                "header":"No Matching Searches"
            })
        }
        
    }

    useEffect(()=>{

    },[matchingsearch])


    return (
        <div style={{display:'flex',flexDirection:'column',backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundSize:'cover',minHeight:'100vh',height:'auto',backgroundPositionX:'-1em'}}>
        <div style={{         
            display:'flex',
            flexDirection:'column',
            alignItems:'center',
            overflow:'visible'
            }}>
            <img src={purplebackicon} style={{width:'1.5em',height:'1.5em',position:'absolute',left:'2%',top:'5em',cursor:'pointer'}} onClick={()=>navigate(-1)}/>

           <div className="searchHeader">
               How can we help?
           </div>

           <div style={{
               display:'flex',
               flexDirection:'row',
               backgroundColor:'#FFFFFF',
               alignItems:'center',
               width:'40%',
               marginBottom:'4em',
               height:'3em',
               borderRadius:'16px'
           }}>
               <img src={SearchIcon} style={{width:'2em',height:'1.5em', marginLeft:'0.75em'}}/>
               <input 
               value={search}
               onChange={e=>searchHelp(e.target.value)}
               type="text"
               className="searchInput"
               placeholder="Search keywords"
               />
           </div>

           {
               matchingsearch.length!==0 &&
               <div style={{
                   backgroundColor:'#FFFFFF',
                   position:'absolute',
                   top:'21.5em',
                   width:'36.5%',
                   borderRadius:'16px',
                   padding:'1.5em 1.87em 1.5em 1.5em',
                   border:'1px solid rgba(0,0,0,50%)'
               }}>
                   {
                       matchingsearch.map((match)=>{
                           return (
                               <div>
                                   <div className="SearchHeader">{match.header}</div>
                                   <div className="SearchDesc">{match.desc}</div>
                               </div>
                           )
                       })
                   }
               </div>
           }
          

           
       </div>
       
       <div style={{
           backgroundColor:'#F9FCFF',               
           width:'100%',
           paddingBottom:'2.5em',
           overflow:'visible',
           display:'flex',
           alignItems:'center',
           justifyContent:'center'
       }}>
           <div style={{
                display:'flex',
                flexDirection:'row',
                flexWrap:'wrap',
                alignItems:'center',
                justifyContent:'center',
                width:'100%',
                maxWidth:'80em',
                alignSelf:'center'
           }}>
          
               <div className="helpBox">
               <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                           <div className="helpboxHeader">
                               Getting Started
                           </div>

                       
                               <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Account Setup");navigate("/help/info")}}>
                                   &#x2022; &nbsp; Account Setup
                               </div>

                               <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Dashboard Overview");navigate("/help/info")}}>
                                   &#x2022; &nbsp; Dashboard Overview
                               </div>

                               <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("First Upload");navigate("/help/info")}}>
                                   &#x2022; &nbsp; First Upload
                               </div>
                           </div>
               </div>

               <div className="helpBox">
           <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                       <div className="helpboxHeader">
                           Music Distribution
                       </div>

                   
                           <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Release Music");navigate("/help/info")}}>
                               &#x2022; &nbsp; Release Music
                           </div>

                           <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Territory & Rights");navigate("/help/info")}}>
                               &#x2022; &nbsp; Territory & Rights
                           </div>

                           <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Royalties");navigate("/help/info")}}>
                               &#x2022; &nbsp; Royalties
                           </div>
                       </div>
           </div>

               <div className="helpBox">
               <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                       <div className="helpboxHeader">
                           Account Management
                       </div>
                           
                        <div className="helpboxOptions"  onClick={()=>{setInfoPageHeader("Billing");navigate("/help/info")}}>
                               &#x2022; &nbsp; Billing & Subscription
                        </div>

                        <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Security");navigate("/help/info")}}>
                               &#x2022; &nbsp; Security
                        </div>

                        <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Profile Updates");navigate("/help/info")}}>
                               &#x2022; &nbsp; Profile Updates
                        </div>

                       </div>
           </div>

          
           


         
               <div className="helpBox">
               <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                           <div className="helpboxHeader">
                               Analytics & Reporting
                           </div>

                       
                               <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Understanding Analytics");navigate("/help/info")}}>
                                   &#x2022; &nbsp; Understanding Analytics
                               </div>

                               <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Performance Tips");navigate("/help/info")}}>
                                   &#x2022; &nbsp; Performance Tips
                               </div>

                               <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Reports Download");navigate("/help/info")}}>
                                   &#x2022; &nbsp; Reports Download
                               </div>

                              
                           </div>
               </div>

               <div className="helpBox">
               <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                       <div className="helpboxHeader">
                           Promotional Tools
                       </div>

                   
                           <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Pre-save Links");navigate("/help/info")}}>
                               &#x2022; &nbsp; Pre-Save Links
                           </div>

                           <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Social Media Integration");navigate("/help/info")}}>
                               &#x2022; &nbsp; Social Media Integration
                           </div>

                           <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("YouTube Monetization");navigate("/help/info")}}>
                               &#x2022; &nbsp; YouTube Monetization
                           </div>

                           <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Get Verified");navigate("/help/info")}}>
                               &#x2022; &nbsp; Get Verified Artist Status
                           </div>
                       </div>
           </div>

           <div className="helpBox">
           <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                       <div className="helpboxHeader">
                       Technical Issues
                       </div>

                   
                           <div className="helpboxOptions">
                               &#x2022; &nbsp; Troubleshooting
                           </div>

                           <div className="helpboxOptions" onClick={()=>{setInfoPageHeader("Submit A ticket");navigate("/help/info")}}>
                               &#x2022; &nbsp; Submit A ticket
                           </div>
                       </div>
           </div>

           <div className="helpBox">
           <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                       <div className="helpboxHeader">
                       Community Forum
                       </div>

                   
                            <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{textDecoration:'none'}}> 
                                <div className="helpboxOptions" >
                                &#x2022; &nbsp; Discussions
                                </div>
                           </a>

                           <div className="helpboxOptions" onClick={()=>navigate('/support')}>
                               &#x2022; &nbsp; Feature Requests
                           </div>

                           
                       </div>
           </div>
       


           <div className="helpBox">
           <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                       <div className="helpboxHeader">
                       Contact Us
                       </div>

                   
                           <div className="helpboxOptions" >
                           <a href="mailto:support@n3rve.com" target="_blank" style={{textDecoration:'none'}} className="helpboxOptions">Support@n3rve.com</a>
                           </div>

                           {/* <div className="helpboxOptions" >
                           Start Live Chat
                           </div> */}

                       </div>
           </div>

           
          

           </div>


       </div>
 

       <div style={{
           display:'flex',
           flexDirection:'column',
           alignItems:'center',
           paddingBottom:'10em'
       }} >
           <div className="supportBottomHeader" style={{textAlign:'center'}}>
               Can’t find what you’re looking for?
           </div>

           <div className="submitRequestBtn" onClick={()=>{navigate("/help/form")}}>
               SUMBIT A REQUEST
               <div className="PostLoginBtnOverlay" />
           </div>
       </div>

    
   </div>
    )
}

export default SupportList;